/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from 'react';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle,  Grid,  LinearProgress,  MenuItem, Paper, Select, SelectChangeEvent, Snackbar, SnackbarCloseReason, TextField } from '@mui/material';
import { ContasReceberService, IListagemContasReceber } from '../../../shared/services/api/Financeiro/ContasReceber';
import { AutoCompleteContaBancaria } from '../../../shared/forms/AutoCompleteContaBancaria';
import { IVFormErrors, VFieldMoney, VForm, VSwitch, VTextFieldData, useVForm } from '../../../shared/forms';
import * as yup from 'yup';

export interface ConfirmationDialogRawProps {
    value: string;
    open: boolean;
    dados?: IListagemContasReceber[];
    vselecionado: number;
    onClose: (value?: string) => void;
    ontotal: (value?: number) => void;
    onDados: (dados?: IListagemContasReceber[]) => void;
}

interface IFormData {
  recebido: number;
  total: number;
  idconta: string;
  datacaixa: Date;
  tipocaixa: boolean;
}
const formValidationSchema: yup.ObjectSchema<IFormData> = yup.object().shape({
  recebido: yup.number().required().min(0.01).test('recebido', 'O Valor Recebido não pode ser maior que o Valor Selecionado', 
    function (value, context) {const valorrecebido = context.parent.total || 0; 
      return value <= valorrecebido && value !== 0;
    }),
  total: yup.number().required(), 
  idconta: yup.string().required(), 
  datacaixa: yup.date().required(), 
  tipocaixa: yup.boolean().required(), 
});


export const DialoBaixa: React.FC<ConfirmationDialogRawProps> = (props: ConfirmationDialogRawProps) => {

  const { onClose, value: valueProp, open, ...other } = props;
  const [value, setValue] = useState(valueProp);
  const { formRef, save, } = useVForm();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [isLoading2, setIsLoading2] = useState(true);
  const [id, setId] = useState('');
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error'  | 'info'  | 'success'>('warning');  
            
  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event, 
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
    if(tms === 'success'){ 
      onClose('true');
    }
  };

  useEffect(() => {
    if(props.dados?.length === 1){
      setIsLoading1(false);
      setIsLoading2(true);
    }else{
      setIsLoading1(true);
      setIsLoading2(false);
    }
    if (props.dados && typeof props.dados === 'object') {
      formRef.current?.setFieldValue('total', props.vselecionado); 
      formRef.current?.setFieldValue('recebido', props.vselecionado); 
    }
  }, [id, formRef]); 

  const handleSave = (dados: IFormData) => {
    formValidationSchema.
      validate(dados, { abortEarly: false })
      .then((dadosValidados) => {
        setIsLoading(true);
        if (props.dados && typeof props.dados === 'object') {
          ContasReceberService
            .Baixa(dadosValidados, props.dados)
            .then((result) => {
              setIsLoading(false);
              if (result instanceof Error) {
                setTms('error');
                setMsg(result.message);
                setOpenmsg(true);
              } else {
                setValue('0');
                setTms('success');
                setMsg('Baixa efetuada com sucesso!');
                setOpenmsg(true);
              }
            });
        }
      })
      .catch((errors: yup.ValidationError) => {
        const validationErrors: IVFormErrors = {};  
        errors.inner.forEach(error => {
          if (!error.path) return;
          validationErrors[error.path] = error.message;
        });
        formRef.current?.setErrors(validationErrors);
      });
  };

  const handleCancel = () => {
    setValue('0');
    onClose('false');
  };

  useEffect(() => {
    if (!open) {
      setValue(valueProp);
    }else{
      setId(valueProp);
    }
  }, [valueProp, open]);


  return (
    <Dialog 
      open={open}
      {...other}
    >
      <DialogTitle>Baixar</DialogTitle>
      <DialogContent dividers>
        <VForm ref={formRef} onSubmit={handleSave}placeholder={undefined} onPointerEnterCapture={undefined}onPointerLeaveCapture={undefined}>
          <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg}  autoHideDuration={900} onClose={handleCloseMsg}>
            <Alert
              onClose={handleCloseMsg}
              severity={tms}
              variant="filled"
              sx={{ width: '100%' }}
            >
              {msg}
            </Alert>
          </Snackbar>
          <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
            <Grid container direction="column" padding={1} spacing={1}>
              {isLoading && (
                <Grid item>
                  <LinearProgress variant='indeterminate' />
                </Grid>
              )}
              <Grid container item direction="row"  spacing={2}>  
                <Grid item  xs={12} sm={12} md={12} lg={12} xl={12}>
                  <AutoCompleteContaBancaria
                    name='idconta'
                    label='Conta Bancaria'
                    isExternalLoading={isLoading}
                  />   
                </Grid> 
                <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                  <VTextFieldData
                    fullWidth
                    size='small'
                    name='datacaixa'  
                    label='Data Recebimento'
                    disabled={isLoading}
                  />
                </Grid>       
                <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                  <VFieldMoney
                    fullWidth
                    size='small'
                    name='total'
                    label='Total'
                    disabled={true}
                  />
                </Grid>  
                <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                  <VSwitch  
                    name='tipocaixa'      
                    label='Juntar Lançamentos'  
                    fdisabled={isLoading2}
                    aliamento='start'
                  /> 
                </Grid>  
                <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                  <VFieldMoney
                    fullWidth
                    size='small'
                    name='recebido'
                    label='Valor Recebido'
                    disabled={isLoading1}
                  />
                </Grid>  
              </Grid> 
            </Grid> 
          </Box>
        </VForm>  
      </DialogContent>
      <DialogActions>
        <Button  variant='outlined' color='error' onClick={handleCancel}>Cancelar</Button>
        <Button variant='outlined' autoFocus onClick={save}>Confirmar</Button>
      </DialogActions>
    </Dialog>
    
  );
};